export default function Section2() {
  return (
    <div className="Section2">
      <div className="section2-container my-[7%] md:my-0 md:justify-evenly md:items-center md:flex px-[20px] md:p-[50px_30px_0px_30px]">
        <div className="md:w-[36%]">
          <h1 className="text-[24px] md:text-[34px] pb-[2%] leading-[32px] md:leading-[41px] font-bold text-[#DA2128] my-[0.67em]">
            Unlock the Power of Email Marketing with Our Expert Services
          </h1>

          <p className="leading-[20px] text-[#373737] pb-[1%] text-[16px] mb-5 font-open">
            In a world filled with digital noise, email marketing remains a
            powerful tool for businesses to connect with their audience, build
            lasting relationships, and drive conversions. At Mean3, we
            understand the potential of email marketing and offer comprehensive
            services tailored to your needs.
          </p>
        </div>

        <div className="w-full img-cont md:w-auto">
          <img
            className="w-full md:w-auto"
            src="/assets/computer-email-marketing.png"
          ></img>
        </div>
      </div>

      <div className="line mx-auto my-[55px] md:my-[4%] w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
